import React from 'react';

export default class AsyncLeadCaptureModal extends React.Component {
  state = { Component: null };

  componentDidMount() {
    import('./index').then(module =>
      this.setState({ Component: module.default })
    );
  }

  render() {
    const { Component } = this.state;
    return Component ? <Component /> : null;
  }
}
